import { __rest } from "tslib";
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import cn from 'classnames';
import FocusLockUI from 'react-focus-lock';
import "./FocusTrap.css";
var styles = { "container": "db9e00", "container_overflowUnset": "ce466e" };
import handleArrowKey from './helpers/handleArrowKey';
import handleClickOutside from './helpers/handleClickOutside';
const FocusTrap = forwardRef((_a, ref) => {
    var { children, onEscape, className, isArrowKeyNavigationActivated, focusLockOverflow = 'auto', wrapperClassName, name, isActive = true } = _a, props = __rest(_a, ["children", "onEscape", "className", "isArrowKeyNavigationActivated", "focusLockOverflow", "wrapperClassName", "name", "isActive"]);
    const innerRef = useRef(null);
    useImperativeHandle(ref, () => innerRef.current);
    useEffect(() => {
        if (isActive) {
            const handleKeyDown = ({ key }) => {
                if (key === 'Escape') {
                    return onEscape();
                }
                return handleArrowKey({ current: innerRef.current, isArrowKeyNavigationActivated, key }, name);
            };
            document.addEventListener('keydown', handleKeyDown, true);
            return () => {
                document.removeEventListener('keydown', handleKeyDown, true);
            };
        }
        return undefined;
    }, [isActive, isArrowKeyNavigationActivated, name, onEscape]);
    useEffect(() => {
        const clickOutside = (event) => handleClickOutside({ current: innerRef.current, event, onEscape }, name);
        document.addEventListener('mousedown', clickOutside);
        return () => {
            document.removeEventListener('mousedown', clickOutside);
        };
    }, [onEscape, name]);
    return (React.createElement(FocusLockUI, { returnFocus: true, className: cn(styles.container, focusLockOverflow === 'unset' && styles.container_overflowUnset, wrapperClassName), disabled: !isActive },
        React.createElement("div", Object.assign({ role: "dialog", "aria-modal": "true", "data-modal-name": name, className: className, ref: innerRef }, props), children)));
});
export default FocusTrap;
//# sourceMappingURL=FocusTrap.js.map